import styled from 'styled-components';

// Targets [data-ref='status-icon'] rather than a bare s-icon selector because SAlert also
// renders an s-icon for its own dismiss/close button — a bare selector would incorrectly
// paint that close icon red too.
export const OfferErrorBannerAlert = styled.div`
  s-icon[data-ref='status-icon'] {
    color: var(--color-alert-error-icon-fg, #fff2f1) !important;
    background-color: var(--color-alert-error-icon-bg, #b91728) !important;
  }
`;
